import { useGetUserCustomers, useGetUserRoles } from '@/generated/client/users/users';

export function useUserFormOptions() {
  const rolesQuery = useGetUserRoles();
  const customersQuery = useGetUserCustomers();
  const roles = rolesQuery.data?.data.roles ?? [];
  const customers = customersQuery.data?.data ?? [];

  async function retryOptions() {
    await Promise.all([rolesQuery.refetch(), customersQuery.refetch()]);
  }

  return {
    customers,
    roles,
    isPending: rolesQuery.isPending || customersQuery.isPending,
    isError:
      (rolesQuery.isError && rolesQuery.data === undefined) ||
      (customersQuery.isError && customersQuery.data === undefined),
    retryOptions,
  };
}
